var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIconwithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 116.989,
    viewBox: "0 0 130 116.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176976",
    "data-name": "Group 176976",
    transform: "translate(12007 10442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145101",
    "data-name": "Rectangle 145101",
    width: 130,
    height: 100,
    transform: "translate(-12007 -10442)",
    fill: "#c50f3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176973",
    "data-name": "Group 176973",
    transform: "translate(-12007 -10442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29998",
    "data-name": "Path 29998",
    d: "M-23.13,0V-7.176h-2.9V-8.46h7.344v1.284h-2.9V0Zm7.224.12a3.7,3.7,0,0,1-1.716-.372,2.644,2.644,0,0,1-1.11-1.056,3.217,3.217,0,0,1-.39-1.62,3.247,3.247,0,0,1,.378-1.6A2.778,2.778,0,0,1-17.7-5.6a2.948,2.948,0,0,1,1.518-.39,2.546,2.546,0,0,1,1.974.792,3.074,3.074,0,0,1,.726,2.16v.444h-4.2a1.6,1.6,0,0,0,1.8,1.572,3.359,3.359,0,0,0,.984-.15,2.7,2.7,0,0,0,.9-.474l.42,1.008a3.138,3.138,0,0,1-1.056.552A4.144,4.144,0,0,1-15.906.12Zm-.216-5.088a1.444,1.444,0,0,0-1.068.408,1.815,1.815,0,0,0-.492,1.1h2.952a1.8,1.8,0,0,0-.4-1.122A1.269,1.269,0,0,0-16.122-4.968ZM-12.27,0V-5.868h1.464v.9a1.913,1.913,0,0,1,.732-.75,2.122,2.122,0,0,1,1.08-.27A1.655,1.655,0,0,1-7.266-4.836a2.046,2.046,0,0,1,.792-.846A2.261,2.261,0,0,1-5.3-5.988q1.98,0,1.98,2.412V0h-1.5V-3.516A1.72,1.72,0,0,0-5.04-4.5a.857.857,0,0,0-.75-.312,1.125,1.125,0,0,0-.924.414A1.77,1.77,0,0,0-7.05-3.252V0h-1.5V-3.516A1.72,1.72,0,0,0-8.772-4.5a.843.843,0,0,0-.738-.312,1.125,1.125,0,0,0-.924.414,1.77,1.77,0,0,0-.336,1.146V0Zm10.5,2.16V-5.868H-.306v.936A1.877,1.877,0,0,1,.456-5.7a2.314,2.314,0,0,1,1.158-.288,2.452,2.452,0,0,1,1.35.372,2.481,2.481,0,0,1,.906,1.05A3.742,3.742,0,0,1,4.194-2.94,3.792,3.792,0,0,1,3.87-1.314a2.483,2.483,0,0,1-.9,1.062A2.444,2.444,0,0,1,1.614.12,2.316,2.316,0,0,1,.492-.15,1.907,1.907,0,0,1-.27-.876V2.16ZM1.194-1.02a1.34,1.34,0,0,0,1.08-.486A2.182,2.182,0,0,0,2.682-2.94a2.153,2.153,0,0,0-.408-1.434,1.355,1.355,0,0,0-1.08-.474,1.355,1.355,0,0,0-1.08.474A2.153,2.153,0,0,0-.294-2.94,2.182,2.182,0,0,0,.114-1.506,1.34,1.34,0,0,0,1.194-1.02ZM7.47.12A1.942,1.942,0,0,1,5.928-.45a2.476,2.476,0,0,1-.5-1.674V-8.46h1.5V-2.2q0,1.08.912,1.08.132,0,.264-.012a1.277,1.277,0,0,0,.252-.048L8.334.012A3.551,3.551,0,0,1,7.47.12Zm3.72,0a2.527,2.527,0,0,1-1.134-.246,1.963,1.963,0,0,1-.78-.666,1.662,1.662,0,0,1-.282-.948A1.489,1.489,0,0,1,9.33-2.766a2.006,2.006,0,0,1,1.092-.546A9.736,9.736,0,0,1,12.45-3.48h.42v-.252a1.188,1.188,0,0,0-.264-.864,1.227,1.227,0,0,0-.888-.264,3.6,3.6,0,0,0-1.008.15,4.561,4.561,0,0,0-1.044.462l-.432-1.02a3.442,3.442,0,0,1,.738-.378,5.318,5.318,0,0,1,.9-.252,4.8,4.8,0,0,1,.894-.09,2.68,2.68,0,0,1,1.908.594A2.436,2.436,0,0,1,14.3-3.552V0h-1.4V-.936a1.638,1.638,0,0,1-.648.774A1.928,1.928,0,0,1,11.19.12ZM11.5-.912a1.3,1.3,0,0,0,.978-.408,1.433,1.433,0,0,0,.39-1.032v-.264h-.408a4.794,4.794,0,0,0-1.566.174.63.63,0,0,0-.438.63.838.838,0,0,0,.276.648A1.1,1.1,0,0,0,11.5-.912ZM18.51.12a2.047,2.047,0,0,1-2.328-2.3V-4.74H15.054V-5.868h1.128V-7.62h1.5v1.752h1.776V-4.74H17.682v2.472a1.28,1.28,0,0,0,.252.864,1.032,1.032,0,0,0,.816.288,1.53,1.53,0,0,0,.348-.042q.18-.042.372-.09l.228,1.1a2.013,2.013,0,0,1-.546.192A3.008,3.008,0,0,1,18.51.12Zm4.752,0a3.7,3.7,0,0,1-1.716-.372,2.644,2.644,0,0,1-1.11-1.056,3.217,3.217,0,0,1-.39-1.62,3.247,3.247,0,0,1,.378-1.6A2.778,2.778,0,0,1,21.468-5.6a2.948,2.948,0,0,1,1.518-.39A2.546,2.546,0,0,1,24.96-5.2a3.074,3.074,0,0,1,.726,2.16v.444h-4.2a1.6,1.6,0,0,0,1.8,1.572,3.359,3.359,0,0,0,.984-.15,2.7,2.7,0,0,0,.9-.474l.42,1.008a3.138,3.138,0,0,1-1.056.552A4.144,4.144,0,0,1,23.262.12Zm-.216-5.088a1.444,1.444,0,0,0-1.068.408,1.815,1.815,0,0,0-.492,1.1h2.952a1.8,1.8,0,0,0-.4-1.122A1.269,1.269,0,0,0,23.046-4.968Z",
    transform: "translate(65 63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(53.078 17.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2347",
    "data-name": "Path 2347",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21061",
    "data-name": "Path 21061",
    d: "M1.169,1.37V5.48h21.04V1.37H1.169m0-1.37h21.04a1.21,1.21,0,0,1,1.169,1.37V6.576a.276.276,0,0,1-.234.274H.234A.276.276,0,0,1,0,6.576V1.37A1.21,1.21,0,0,1,1.169,0Z",
    transform: "translate(0.383 0.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21061_-_Outline",
    "data-name": "Path 21061 - Outline",
    d: "M1.353-.15H22.491a1.571,1.571,0,0,1,1.5,1.753V6.809a.632.632,0,0,1-.563.657H.413A.632.632,0,0,1-.15,6.809V1.6A1.571,1.571,0,0,1,1.353-.15ZM23.337,6.7V1.6c0-.609-.324-.987-.846-.987H1.353C.831.616.507.994.507,1.6V6.7ZM1.024,1.22h21.8V6.1H1.024Zm21.138.766H1.681V5.33H22.163Z",
    transform: "translate(0.15 0.15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2348",
    "data-name": "Path 2348",
    transform: "translate(5.417 5.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21062",
    "data-name": "Path 21062",
    d: "M23.256,23.941H7.5V7.5H23.941V23.256A.618.618,0,0,1,23.256,23.941Z",
    transform: "translate(-6.432 -6.432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21062_-_Outline",
    "data-name": "Path 21062 - Outline",
    d: "M23.489,24.557H7.35V7.35H24.557V23.489A1,1,0,0,1,23.489,24.557ZM8.116,23.791H23.489c.229,0,.3-.073.3-.3V8.116H8.116Z",
    transform: "translate(-6.665 -6.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21063",
    "data-name": "Path 21063",
    d: "M8.37,8.37V23.441H23.441V8.37H8.37M7.274,7H24.537a.3.3,0,0,1,.274.274V23.441a1.294,1.294,0,0,1-1.37,1.37H7.274A.3.3,0,0,1,7,24.537V7.274A.3.3,0,0,1,7.274,7Z",
    transform: "translate(-6.617 -6.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21063_-_Outline",
    "data-name": "Path 21063 - Outline",
    d: "M7.507,6.85H24.77a.674.674,0,0,1,.657.657V23.674a1.677,1.677,0,0,1-1.753,1.753H7.507a.674.674,0,0,1-.657-.657V7.507A.674.674,0,0,1,7.507,6.85Zm17.154.766H7.616V24.661H23.674a.916.916,0,0,0,.987-.987ZM8.22,8.22H24.057V24.057H8.22Zm15.071.766H8.986v14.3h14.3Z",
    transform: "translate(-6.85 -6.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2349",
    "data-name": "Path 2349",
    transform: "translate(-0.15 5.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21064",
    "data-name": "Path 21064",
    d: "M5.98,23.941h-4.8A.618.618,0,0,1,.5,23.256V7.5H5.98Z",
    transform: "translate(0.568 -6.432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21064_-_Outline",
    "data-name": "Path 21064 - Outline",
    d: "M6.6,24.557H1.418A1,1,0,0,1,.35,23.489V7.35H6.6ZM1.116,8.116V23.489c0,.229.073.3.3.3H5.83V8.116Z",
    transform: "translate(0.335 -6.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065",
    "data-name": "Path 21065",
    d: "M1.37,8.37V23.441H5.48V8.37H1.37M.274,7h6.3a.3.3,0,0,1,.274.274V24.537a.3.3,0,0,1-.274.274H1.37A1.294,1.294,0,0,1,0,23.441V7.274A.3.3,0,0,1,.274,7Z",
    transform: "translate(0.383 -6.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065_-_Outline",
    "data-name": "Path 21065 - Outline",
    d: "M.507,6.85h6.3a.674.674,0,0,1,.657.657V24.77a.674.674,0,0,1-.657.657H1.6A1.677,1.677,0,0,1-.15,23.674V7.507A.674.674,0,0,1,.507,6.85ZM6.7,7.616H.616V23.674a.916.916,0,0,0,.987.987H6.7Zm-5.48.6H6.1V24.057H1.22Zm4.11.766H1.986v14.3H5.33Z",
    transform: "translate(0.15 -6.85)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29176",
    "data-name": "Path 29176",
    d: "M2.092,0H23.013L0,23.013V2.092A2.092,2.092,0,0,1,2.092,0Z",
    transform: "translate(-11942 -10357.557) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIconwithBg);
export default __webpack_public_path__ + "static/media/TemplateIconwithBg.37f14bfd6f9879cdb76e211615588417.svg";
export { ForwardRef as ReactComponent };